import React from "react";
import Slider from "react-slick";
import thirdVideo from "../../assets/videos/thirdVideo.mp4";
import secondVideo from "../../assets/videos/secondVideo.mp4";
import firstVideo from "../../assets/videos/firstVideo.mp4";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";

const VideoCarousel = () => {
  const settings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // Remove arrows for cleaner mobile look
  };

  const videos = [
    {
      src: firstVideo,
      title: "Transform Data into Results: Your AI Advantage Starts Here.",
      subtitle:
        "Start your AI journey with tailored solutions to drive growth and innovation.",
    },
    {
      src: secondVideo,
      title: "Your AI Transformation Partner",
      subtitle:
        "Partner with us to unlock the true value of AI and scale your business like never before.",
    },
    {
      src: thirdVideo,
      title: "Maximize ROI with Smarter AI",
      subtitle:
        "Leverage intelligent AI strategies to boost your efficiency and profitability.",
    },
  ];

  return (
    <div className="relative w-full h-screen">
      {" "}
      {/* Full viewport height */}
      <Slider {...settings} className="h-full">
        {videos.map((video, index) => (
          <div key={index} className="relative h-screen">
            {" "}
            {/* Each slide full height */}
            <video
              className="absolute inset-0 w-full h-full object-cover"
              muted
              loop
              autoPlay
              playsInline // Important for iOS
              preload="auto"
            >
              <source src={video.src} type="video/mp4" />
            </video>
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white text-center px-4">
              <div className="max-w-4xl mb-40">
                <motion.h1
                  className="text-3xl md:text-5xl font-bold mb-4"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                >
                  {video.title}
                </motion.h1>
                <motion.p
                  className="text-lg md:text-xl"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                >
                  {video.subtitle}
                </motion.p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default VideoCarousel;
